import './Logo.css';

export default function Logo() {
    return `
        <div class="navbar__brand-container">
            <div class="navbar__logo-left">
                <div class="navbar__logo-title">PIEROGY</div>
                <div class="navbar__logo-year-wrapper">
                    <div class="navbar__logo-line"></div>
                    <div class="navbar__logo-year">2027</div>
                </div>
            </div>
        </div>
    `;
}
